import types from "./types";

export function allHorarios() {
  return { type: types.ALL_HORARIOS };
}
export function updateHorario(payload) {
    return { type: types.UPDATE_HORARIO , payload};
  }
  
  export function filterHorarios() {
    return { type: types.FILTER_HORARIO };
  }
  export function addHorario() {
    return { type: types.ADD_HORARIO };
  }
  export function resetHorario() {
    return { type: types.RESET_HORARIO };
  }
  export function removeHorario() { //Soft Remove
    return { type: types.REMOVE_HORARIO };
  }
  export function allServicios() { //Soft Remove
    return { type: types.ALL_SERVICES };
  }
  